module.exports = "/_next/static/images/video_id_7116394628101786923-25c213d9bb2ef6738f1b85b27d9dba9a.jpg";